// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2zutd","fondo_header":"Header_fondo_header__KVR2M","img_logo":"Header_img_logo__8ey5C"};